module.exports = __webpack_public_path__ + "img/Sistema-PDV-Movel.25031c16.jpg";